import React, { useRef, useState } from 'react';
import { Dropdown, Typography } from '@hmsexp/component-library';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import get from 'lodash/get';
import useTransformAdditionalMetricsData from './useTransformAdditionalMetricsData';
import GenericNoData from '../../../../../../components/Common/NoData/GenricNoData';
import { View } from '../../../../../../components/Common/react-native-components';
import MultiFeatureCard from '../../../../../../components/Common/Card/MultiOptionsCard/MultiFeatureCard';
import { additionalMetrixStyling } from './style';
import { ADDITIONAL_METRIX_OPTIONS } from '../../../../constants';
import { dropdownStyling } from '../style';
import { handleHighChartsExport } from '../../../../utils';

const AdditionalMetricsComparisonWidget = ({ item, timeperiodLabel }) => {
    const [selectedMetrix, setSelectedMetrix] = useState('percentage');
    const {
        isData,
        subTitle,
        options,
        chartOptions,
        selectedMetrixLabel
    } = useTransformAdditionalMetricsData(item, timeperiodLabel, selectedMetrix);

    const chartRef = useRef(null);
    const styles = additionalMetrixStyling();

    const color = get(options, 'series[0].color');

    const renderContent = (_, contentRef) => {
        if (contentRef) {
            contentRef.current = {
                actionButtonClick: (e) => handleHighChartsExport(e, chartRef, { ...item, subTitle })
            };
        }

        if (!isData) {
            return <GenericNoData />;
        }

        return (
            <View>
                <Typography
                    textProps={{ style: { marginBottom: 5 } }}
                    variant='button'
                    color='primaryContentMedium'
                    fontWeightType='regular'>
                    {get(item, "config.dropdownLabel")}
                </Typography>

                <View style={{ maxWidth: 200 }}>
                    <Dropdown
                        items={ADDITIONAL_METRIX_OPTIONS}
                        onChange={setSelectedMetrix}
                        value={selectedMetrix}
                        label={''}
                        style={{
                            container: {
                                ...dropdownStyling.container
                            },
                            optionContainer: dropdownStyling.optionContainer,
                            dropDownText: dropdownStyling.dropDownText,
                            icon: dropdownStyling.icon
                        }}
                    />
                </View>
                <HighchartsReact ref={chartRef} highcharts={Highcharts} options={chartOptions} />
                <View style={{ flexDirection: 'row' }}>
                    <View style={[styles.selectedMetrixContainer, { borderColor: color }]}>
                        <View style={{ width: 10, height: 10, backgroundColor: color }}></View>
                        <Typography fontWeightType='regular' variant='button'>
                            {selectedMetrixLabel}
                        </Typography>
                    </View>
                </View>
            </View>
        );
    };

    return (
        <MultiFeatureCard
            title={get(item, 'title')}
            subTitle={subTitle}
            renderContent={renderContent}
            enableActionBtn={true}
            style={{ childContainer: { paddingVertical: 20 } }}
            enableSwitchTab={get(item, 'enableSwitchTab')}
            switchOptions={get(item, 'switchOptions')}
            renderFooter={() => (
                <Typography fontWeightType='regular' variant='button'>
                    {get(item, 'footerText')}
                </Typography>
            )}
        />
    );
};

export default AdditionalMetricsComparisonWidget;